import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box,
  Button,
  DashboardModule,
} from '@domain-group/suit-theme'

import useProviderService from '@hooks/useProviderService'
import useProviderServices from '@hooks/useProviderServices'

import ServiceListItem from './ServiceListItem'

const Services = (props) => {
  const { providerId } = props

  const providerServicesPayload = useProviderServices({
    filters: { provider_id: providerId },
    performHttpRequests: !!providerId,
  })

  const {
    filteredProviderServices,
    hasFilteredProviderServices,
    loading,
  } = providerServicesPayload

  const providerServicePayload = useProviderService({ provider_id: providerId })
  const {
    callbacks: { createOrEditProviderService },
  } = providerServicePayload

  return (
    <DashboardModule
      loading={loading}
      title="Services"
    >
      <Box flexDirection="column">
        {!loading && !hasFilteredProviderServices && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Services present
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              Please assign one below.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {!loading && hasFilteredProviderServices && (
          <Box flexDirection="column">
            {filteredProviderServices.map(providerService => (
              <ServiceListItem key={providerService.id} providerService={providerService} />
            ))}
          </Box>
        )}

        <DashboardModule.Footer boxProps={{ borderTop: loading ? 'none' : '1px solid' }}>
          <DashboardModule.FooterRight>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => createOrEditProviderService()}
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Add Service
            </Button>
          </DashboardModule.FooterRight>
        </DashboardModule.Footer>
      </Box>
    </DashboardModule>
  )
}

Services.propTypes = {
  providerId: PropTypes.number.isRequired,
}

export default Services
